import { Link } from 'react-router';

import { cn } from '~/styling';
import { imgUrl } from '~/urls';

import { buttonVariants } from '~/local/components/button';
import { gradient as gradientStyle } from '~/styling/gradients';

const Hero = ({
  heading,
  text,
  cta,
  image,
  type = 1,
  gradient = 2,
}: {
  heading: string;
  text: string;
  image: {
    src: string;
    width: number;
    height: number;
  };
  cta: {
    text: string;
    to?: string; // Make 'to' optional
    disabled?: boolean;
    onClick?: () => void;
  };
  type?: 1 | 2;
  gradient?: 2 | 3;
}) => {
  return (
    <div
      className={cn(
        'relative flex h-full overflow-hidden p-6 lg:p-12',
        {
          1: 'flex-col',
          2: 'flex-col-reverse',
        }[type],
        gradientStyle({ style: gradient })
      )}
    >
      <picture>
        {[1280, 1024, 768].map((width) => (
          <source
            key={width}
            srcSet={imgUrl(image.src, {
              width,
              height: image.height,
            })}
            media={`(min-width: ${width}px)`}
          />
        ))}
        <img
          className="absolute top-0 left-0 -z-10 h-full w-full object-cover object-center"
          srcSet={imgUrl(image.src, {
            width: 640,
            height: image.height,
          })}
          loading="lazy"
          alt={heading}
        />
      </picture>
      <div className="text-neutral-1 flex flex-col gap-4 lg:w-1/2">
        <h3 className="font-heading-condensed text-xl leading-7 font-medium tracking-tight lg:text-4xl lg:leading-9">
          {heading}
        </h3>
        <p className="text-medium leading-6">{text}</p>
        {cta.disabled ? (
          <span
            className={buttonVariants({
              intent: 'primary',
              mode: 'disabled',
              className: 'w-max',
            })}
          >
            {cta.text}
          </span>
        ) : cta.onClick ? (
          <button onClick={cta.onClick} className={buttonVariants({ className: 'w-max cursor-pointer' })}>
            {cta.text}
          </button>
        ) : cta.to ? (
          <Link
            data-testid="hero-button"
            to={cta.to}
            className={buttonVariants({ className: 'w-max' })}
          >
            {cta.text}
          </Link>
        ) : null}
      </div>
    </div>
  );
};

export default Hero;
